import type { FC } from 'react';

import { ClickableDiv } from '@wwe-portal/ui/components/button';
import ClaimAllIcon from '@wwe-portal/ui/components/icons/claim-all-icon';
import { Each } from '@wwe-portal/ui/components/utils';
import sectionTitleBg from '@wwe-portal/ui/assets/images/section-title-mission.webp';

import { MilestoneCarousel } from './milestone-carousel';
import type { MilestoneCollectionProps } from './milestone-collection';
import type { MilestonePeriodData } from './milestone-period';

const PeriodTypeEnum = {
  DAY: 1,
  WEEK: 2,
  MONTH: 3,
  YEAR: 4,
};

const PeriodType = {
  [PeriodTypeEnum.DAY]: 'Daily',
  [PeriodTypeEnum.WEEK]: 'Weekly',
  [PeriodTypeEnum.MONTH]: 'Monthly',
  [PeriodTypeEnum.YEAR]: 'Yearly',
};

export const MilestoneCollectionV2: FC<
  MilestoneCollectionProps & {
    onMissionSectionClick?: (type: number) => void | undefined;
  }
> = ({
  milestonePeriods,
  onMissionDetails,
  defaultMileStonePeriods,
  onMissionSectionClick,
}) => {
  const newMilestonePeriods = [
    ...(defaultMileStonePeriods ?? []),
    ...(milestonePeriods ?? []),
  ].reduce((acc: Record<string, MilestonePeriodData[]>, curr) => {
    acc[curr.periodType] = acc[curr.periodType] ?? [];
    acc[curr.periodType]?.push(curr);
    return acc;
  }, {});

  const milestoneDatas = Object.values(newMilestonePeriods);

  return (
    <div className="flex flex-col">
      <Each
        data={milestoneDatas}
        render={(item) => {
          const claimableCount = item.filter(
            (i) => !i.isClaimed && i.endPoint === i.currentPoint
          ).length;

          return (
            <div>
              <div
                className="relative mt-5 flex h-[40px] w-full items-center justify-start bg-cover bg-left bg-no-repeat"
                style={{ backgroundImage: `url(${sectionTitleBg})` }}
              >
                <span className="inline px-4 text-base font-semibold text-white">
                  {PeriodType[item[0]?.periodType ?? 1]}
                </span>
                <ClickableDiv
                  className="absolute right-11 drop-shadow-[2px_2px_2px_rgba(0,0,0,0.35)]"
                  onClick={() =>
                    onMissionSectionClick &&
                    onMissionSectionClick(item[0]?.periodType ?? 0)
                  }
                >
                  <ClaimAllIcon />
                </ClickableDiv>
                <div className="absolute right-2 rounded-[3px] bg-[#1A1919] bg-center bg-no-repeat p-1 drop-shadow-[2px_2px_2px_rgba(0,0,0,0.35)]">
                  {claimableCount}/{item.length}
                </div>
              </div>
              <div className="overflow-hidden pt-3">
                <MilestoneCarousel
                  defaultMileStonePeriods={defaultMileStonePeriods}
                  milestonePeriods={item}
                  onMissionDetails={onMissionDetails}
                />
              </div>
            </div>
          );
        }}
      />
    </div>
  );
};
